import { connect } from 'react-redux';
import EditCourse from './EditCourse';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(EditCourse);
